// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"8f23f1ba","344":"95a61e5a","370":"09a6108d","453":"74768ed2","672":"36198a73","690":"b9d05268","750":"0cbbbbc0","977":"8556eda8"}[chunkId] + ".chunk.js";
};